module.exports = __webpack_public_path__ + "4bc88be55926ff9781f3d42ef726b231.svg";